// Application constants

// Time tracking
export const MAX_HOURS_PER_DAY = 24;
export const DEFAULT_WORK_HOURS = 8;
export const MISSING_HOURS_ALERT_DAY = 20; // Alert on 20th of month

// Pagination
export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;

// Auth
export const ACCESS_TOKEN_EXPIRY = 24 * 60 * 60; // 24 hours in seconds
export const REFRESH_TOKEN_EXPIRY = 90 * 24 * 60 * 60; // 90 days in seconds
export const REMEMBER_ME_EXPIRY = 180 * 24 * 60 * 60; // 180 days in seconds
export const PASSWORD_RESET_EXPIRY = 60 * 60; // 1 hour in seconds

// Password requirements (relaxed as requested)
export const PASSWORD_MIN_LENGTH = 6;

// Timezones (common US timezones first)
export const TIMEZONES = [
  { value: 'America/New_York', label: 'Eastern Time (ET)' },
  { value: 'America/Chicago', label: 'Central Time (CT)' },
  { value: 'America/Denver', label: 'Mountain Time (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time (HT)' },
  { value: 'UTC', label: 'UTC' },
  { value: 'Europe/London', label: 'London (GMT/BST)' },
  { value: 'Europe/Paris', label: 'Paris (CET/CEST)' },
  { value: 'Europe/Berlin', label: 'Berlin (CET/CEST)' },
  { value: 'Asia/Tokyo', label: 'Tokyo (JST)' },
  { value: 'Asia/Shanghai', label: 'Shanghai (CST)' },
  { value: 'Asia/Kolkata', label: 'Mumbai (IST)' },
  { value: 'Australia/Sydney', label: 'Sydney (AEST/AEDT)' },
] as const;

// Project colors
export const PROJECT_COLORS = [
  '#3B82F6', // Blue
  '#10B981', // Green
  '#F59E0B', // Amber
  '#EF4444', // Red
  '#8B5CF6', // Purple
  '#EC4899', // Pink
  '#06B6D4', // Cyan
  '#F97316', // Orange
  '#6366F1', // Indigo
  '#84CC16', // Lime
] as const;

// Priority colors
export const PRIORITY_COLORS = {
  low: '#6B7280', // Gray
  medium: '#3B82F6', // Blue
  high: '#F59E0B', // Amber
  urgent: '#EF4444', // Red
} as const;

// Status colors
export const PROJECT_STATUS_COLORS = {
  active: '#10B981', // Green
  completed: '#6B7280', // Gray
  on_hold: '#F59E0B', // Amber
  archived: '#374151', // Dark gray
} as const;

export const TASK_STATUS_COLORS = {
  pending: '#6B7280', // Gray
  in_progress: '#3B82F6', // Blue
  completed: '#10B981', // Green
  deleted: '#EF4444', // Red
} as const;

// Timesheet
export const TIMESHEET_TARGET_HOURS = 40;

export const TIMESHEET_STATUS_COLORS = {
  draft: '#6B7280', // Gray
  submitted: '#3B82F6', // Blue
  approved: '#10B981', // Green
  rejected: '#EF4444', // Red
} as const;
